import Vue from 'vue';
import App from './App.vue';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import Carousel3d from 'vue-carousel-3d';

import VueDragscroll from 'vue-dragscroll'
Vue.use(VueDragscroll)


// 兼容IE   开始
import '@babel/polyfill'
import Es6Promise from 'es6-promise';
require('es6-promise').polyfill()
Es6Promise.polyfill();
// 兼容IE   结束
// 引入router
import router from './router';
// 引入store
import store from './store';
// px2rem 自适应
import 'lib-flexible'
// 引入公用的样式文件
import './assets/css/base.css';
// import './assets/css/css.css';
import './assets/css/other.css';
// 引入公用的js
import $ from './assets/js/js.js'
import $city from './assets/js/citys.js'
// import vConsole from './http/vconsole'//手机端控制台
//swiper css
// import 'swiper/';
// 网络请求
// import {
//     deleteRequest,
//     getRequest,
//     postRequest,
//     putRequest,
//     uploadFileRequest
// } from './http/httpUtil'
//接口
import {
    deleteRequest,
    getRequest,
    postRequest,
    putRequest,
    uploadFileRequest,
    makeFormData
} from './api/index'
import {
    ApiConstant
} from './api/ApiConstant'

let options = {
    fullscreenEl: false,
}
Vue.use(preview, options)
Vue.use(ElementUI)
Vue.use(Antd);
Vue.use(Carousel3d);

Vue.prototype.$ = $
// Vue.prototype.$city = $city
// Vue.prototype.$getRequest = getRequest
// Vue.prototype.$postRequest = postRequest
// Vue.prototype.$deleteRequest = deleteRequest
// Vue.prototype.$putRequest = putRequest
// Vue.prototype.$uploadFileRequest = uploadFileRequest
// Vue.prototype.$apiConstant = ApiConstant
Vue.prototype.$eventBus = new Vue()
Vue.prototype.$get = getRequest
Vue.prototype.$post = postRequest
Vue.prototype.$delete = deleteRequest
Vue.prototype.$put = putRequest
Vue.prototype.$uploadFileRequest = uploadFileRequest
Vue.prototype.$makeForm = makeFormData
Vue.prototype.$host = "http://mp.boruankeji.net"
// Vue.prototype.$host = "http://192.168.6.9:8002"

Vue.config.productionTip = false;
Vue.directive('document-click', {
    bind(el, binding, vnode) {
        document.addEventListener('click', binding.value, false)
    },
    inserted() {
        console.log('insert')
    },
    update() {
        console.log('update')
    }
})
router.beforeEach((to, from, next) => {
    // 如果路由不一样，滚动到最顶部
    if (to.name != from.name) {
        window.scrollTo(0, 0);
    }
    if (to.meta.title) {
        $.title(to.meta.title);
    }
    next();
})

new Vue({
    render: h => h(App),
    // 路由
    router,
    // 使用store
    store,
}).$mount('#app')